import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'cui-select-all',
  templateUrl: './select-all.component.html',
  styleUrls: ['./select-all.component.scss']
})
export class SelectAllComponent implements OnInit {

  @Input()
  options: any[];

  @Input()
  property?: string;

  @Input()
  selectLabel = 'Select all';

  @Input()
  deselectLabel = 'Deselect all';

  @Input()
  controlForm: FormControl;

  allSelected = false;

  ngOnInit(): void {
    this.allSelected = this.allAreSelected();
    this.controlForm.valueChanges.subscribe(() => this.allSelected = this.allAreSelected());
  }

  toggleSelectAll() {
     if (this.allSelected) {
      this.controlForm.setValue([]);
      this.allSelected = false;
    } else {
      this.controlForm.setValue(this.mapToProperty(this.options));
      this.allSelected = true;
    }
  }

  private allAreSelected() {
    return this.controlForm.value.length === this.options.length;
  }

  private mapToProperty(array: any[]) {
    if (this.property) {
      return array.map(obj => obj[this.property]);
    }

    return array;
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/select-all/select-all.component.ts